import { Spinner } from "reactstrap"
import '../../Assets/css/Main.css';


const Loader = () => {
    return (
        <>
            <div className="col-12">
                <div className="text-center pt-3 pb-3">
                    <Spinner style={{ width: '2rem', height: '2rem' }} />
                </div>
            </div>
        </>
    )
}

export default Loader


